import gql from 'graphql-tag';

export const GENERATE_SUMMARY = gql`
  mutation GenerateSummary($input: GenerateSummaryInput!) {
    generateSummary(input: $input) {
      content {
        summary
        reasoning
      }
    }
  }
`;
